export const isUnauthorizedError = (error) => error.status === 401;
export const isForbiddenError = (error) => error.status === 403;
export const isServiceUnavailableError = (error) => error.status === 503;

/**
 * List of the custom status codes we support for Glimmer custom errors.
 *
 * @type {Object}
 */
export const SH_CUSTOM_ERROR_CODES = {
  ERROR_CODE_USER_HAS_OPEN_PROJECTS: 100,
  ERROR_CODE_INVITED_USER_ALREADY_PART_OF_TEAM: 101,
  ERROR_CODE_INVITED_USER_ALREADY_HAS_ACCOUNT: 102,
  ERROR_CODE_INVITED_USER_HAS_EXTERNAL_ACCOUNT: 103,
  ERROR_CODE_NEEDS_CREDIT_CARD: 1001,
  ERROR_CODE_PAYOUT_ACCOUNT_REQUIRED: 5002,
  CODE_ADVANCE_GREATER_THAN_TOTAL: 5003,
};

/**
 * The possible indices for different errors in the ErrorHandler
 *
 * @type {Object}
 */
export const SH_ERROR_INDEX = {
  CUSTOM_ERROR_CODE: 'sh-error-code', // maps to a SH_CUSTOM_ERROR_CODES.*
  CUSTOM_ERROR_BODY: 'sh-error-body', // When we have a 'sh-error-code' this might have a message from the server.
  GENERIC_EXCEPTION: 'generic-exception', // When something bad happens, we'll try to put the best string representation in this
};

const CUSTOM_ERROR_CODES = Object.keys(SH_CUSTOM_ERROR_CODES).reduce((accum, key) => {
  accum[SH_CUSTOM_ERROR_CODES[key]] = key;
  return accum;
}, { })

const genericException = (message) => ({
  [SH_ERROR_INDEX.GENERIC_EXCEPTION]: [message],
});

const tryParseOrGenericException = (payload) => {
  try {
    return JSON.parse(payload);
  } catch {
    return genericException(payload);
  }
};

export const normalizeErrors = (payload) => {
  if (typeof payload === 'string') {
    return genericException(payload);
  }

  const customCode = payload.data?.attributes?.code;
  const body = payload.data?.attributes?.body;

  if (customCode && CUSTOM_ERROR_CODES[customCode]) {
    return {
      [SH_ERROR_INDEX.CUSTOM_ERROR_CODE]: customCode,
      [SH_ERROR_INDEX.CUSTOM_ERROR_BODY]: body,
    };
  }

  if (body) {
    return tryParseOrGenericException(body);
  } else if (payload.message) {
    return tryParseOrGenericException(payload.message);
  }

  return genericException('There was an unknown error');
};
